import { belegLayout, type BelegArt, type BelegLayout } from "@talentkontor/domain";
import { api } from "../data";

/**
 * PDF-Vorlagen der Agentur (0456): Liste, Speichern und die für einen Beleg geltende Vorlage (Marke vor Standard der
 * Agentur, document_template_for). Ohne Vorlage bleibt der Beleg wie bisher; ein Fehler beim Laden ändert am Beleg nichts.
 */

export interface BelegVorlage {
  id: string;
  org_id: string;
  kind: BelegArt;
  name: string;
  is_default: boolean;
  settings: Record<string, unknown>;
  updated_at: string;
}

const SPALTEN = "id,org_id,kind,name,is_default,settings,updated_at";

export function listeVorlagen(orgId: string): Promise<BelegVorlage[]> {
  return api.select<BelegVorlage>("document_templates", { columns: SPALTEN, filters: [["org_id", "eq", orgId]], order: [["kind", "asc"], ["name", "asc"]] });
}

export async function vorlageLaden(orgId: string, id: string): Promise<BelegVorlage | null> {
  const r = await api.select<BelegVorlage>("document_templates", { columns: SPALTEN, filters: [["org_id", "eq", orgId], ["id", "eq", id]], limit: 1 });
  return r[0] ?? null;
}

export async function vorlageAnlegen(orgId: string, kind: BelegArt, name: string, settings: BelegLayout, standard: boolean): Promise<string> {
  const r = await api.insert<{ id: string }>("document_templates", { org_id: orgId, kind, name: name.trim(), settings, is_default: standard }, { columns: "id" });
  if (!r[0]?.id) throw new Error("Die Vorlage wurde nicht gespeichert.");
  return r[0].id;
}

export function vorlageSpeichern(id: string, patch: { name?: string; settings?: BelegLayout; is_default?: boolean }): Promise<unknown> {
  return api.update("document_templates", [["id", "eq", id]], { ...patch }, { returning: false });
}

export function vorlageLoeschen(id: string): Promise<unknown> {
  return api.remove("document_templates", [["id", "eq", id]]);
}

/** Vorlage für einen Beleg: die der Marke, sonst der Standard der Agentur, sonst null (Beleg wie bisher) */
export async function geltendeVorlage(orgId: string, kind: BelegArt, brandId?: string | null): Promise<BelegLayout | null> {
  try {
    const r = await api.read<Record<string, unknown> | null>("document_template_for", { p_org: orgId, p_kind: kind, p_brand: brandId ?? null });
    return r && typeof r === "object" ? belegLayout(r) : null;
  } catch {
    return null;
  }
}
